import { useEffect } from 'react';

/**
 * Custom hook to update the PWA app icon badge
 * Shows notification count on the app icon (like Instagram, WhatsApp, etc.)
 * 
 * @param {number} count - The number to display on the badge (0 to clear)
 */
export const useBadge = (count) => {
  useEffect(() => {
    // Check if service worker and badging are supported
    if (!('serviceWorker' in navigator)) {
      console.log('Service Worker not supported');
      return;
    }

    const updateBadge = async () => {
      try {
        // Wait for service worker to be ready
        const registration = await navigator.serviceWorker.ready;
        
        if (registration.active) {
          // Send message to service worker to update badge
          registration.active.postMessage({
            type: 'UPDATE_BADGE',
            count: count
          });
          
          console.log(`Badge update requested: ${count}`);
        }

        // Also try direct Badging API (for browsers that support it)
        if ('setAppBadge' in navigator) {
          if (count > 0) {
            await navigator.setAppBadge(count);
            console.log(`Direct badge set: ${count}`);
          } else {
            await navigator.clearAppBadge();
            console.log('Direct badge cleared');
          }
        }
      } catch (error) {
        console.error('Error updating badge:', error);
      }
    };

    updateBadge();
  }, [count]);
};

/**
 * Function to manually clear the badge
 */
export const clearBadge = async () => {
  try {
    if ('clearAppBadge' in navigator) {
      await navigator.clearAppBadge();
      console.log('Badge cleared manually');
    }
    
    // Also notify service worker
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;
      if (registration.active) {
        registration.active.postMessage({
          type: 'UPDATE_BADGE',
          count: 0
        });
      }
    }
  } catch (error) {
    console.error('Error clearing badge:', error);
  }
};
